import './NavBar.css'

export default function NavBar () {
  return (
    <div className="nav-bar">
      <h1>chat.green</h1>
    </div>
  )
}
